import React, { PropsWithChildren } from "react";

import { ReactComponent as CloseIcon } from "@common/assets/images/close-icon.svg";
import QuestionIcon from "@common/assets/images/question-icon-box.svg";
import Tooltip from "@common/components/Tooltip/Tooltip";

import * as Styled from "./InterjectedRows.styles";

export interface InterjectedRowShellProps {
  label: string;
  action: React.ReactNode;
  onDismiss: () => void;
  testId?: string;
  descriptionTooltip: string;
  dismissTooltip?: string;
}

/**
 * Layout shared by every interjected row: full-width span, icon, content, action, dismiss.
 *
 * The three row types differ only in what fills the content and action slots, so the grid span,
 * click isolation and dismiss affordance live here once.
 */
export const InterjectedRowShell = ({
  label,
  action,
  onDismiss,
  testId,
  children,
  descriptionTooltip,
  dismissTooltip,
}: PropsWithChildren<InterjectedRowShellProps>) => {
  return (
    <Styled.Row
      role="region"
      aria-label={label}
      data-testid={testId}
      onClick={(e) => e.stopPropagation()}
    >
      <Styled.TitleCell>
        <Styled.InfoIconWrap>
          <Tooltip
            style={{ width: "auto", display: "flex", alignItems: "center" }}
            text={descriptionTooltip}
            position={"right"}
          >
            <Styled.Info src={QuestionIcon} />
          </Tooltip>
        </Styled.InfoIconWrap>

        {children}
      </Styled.TitleCell>

      <Styled.ActionCell>{action}</Styled.ActionCell>

      <Styled.DismissCell>
        <Tooltip
          style={{ width: "auto" }}
          text={dismissTooltip ?? "Dismiss"}
          position={"right"}
        >
          <Styled.DismissButton
            type="button"
            aria-label={`Dismiss ${label}`}
            data-testid={testId ? `${testId}_dismiss` : undefined}
            onClick={onDismiss}
          >
            <CloseIcon />
          </Styled.DismissButton>
        </Tooltip>
      </Styled.DismissCell>
    </Styled.Row>
  );
};
